// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"b78fe79d","454":"b78fe79d","533":"4d31a616"}[chunkId] + ".chunk.css";
};